// extracted by mini-css-extract-plugin
export default {"stepBox":"Steper_stepBox__X7oJu","fontesLabel":"Steper_fontesLabel__0C9-I"};